<template>
  <v-layout>
    <v-flex xs12>
      <v-card>
        <calendar-view
          :events="events"
        />
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import CalendarView from './CalendarView'

export default {
  components: {
    CalendarView
  },
  data () {
    return {
      events: [
        {
          id: 'abc',
          startDate: new Date(),
          title: 'An Event'
        }
      ]
    }
  }
}
</script>
